import { z } from 'zod';

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;
export type OutputType = void;

// This endpoint redirects, so we don't typically call it via fetch in the same way,
// but we can provide a helper to get the URL or trigger the navigation.
// However, for OAuth popups, we usually just open the window.open with this URL.
// We'll provide a helper that returns the URL string for convenience.

export const getGitHubAuthorizeUrl = () => {
  // Prefer GitHub App installation flow by default
  return `/_api/integrations/github_app_authorize`;
};
